// Les réglages (nouvelle interface, 10 octobre 2026) : le compte, la langue, l'équipe.
export default {
  titre: 'Réglages',
  sousTitre: 'Votre nom, votre langue, votre équipe',
  compte: 'Mon compte',
  langue: 'Langue',
  langueTexte: 'La langue d’Orion pour vous, sur tous vos appareils',
  theme: 'Apparence',
  themeTexte: 'Claire, sombre, ou celle de votre système (elle passe en sombre le soir si votre appareil le fait)',
  themeSysteme: 'Système',
  themeClair: 'Clair',
  themeSombre: 'Sombre',
  equipe: 'Équipe',
  equipeTexte: 'Les membres, les sièges et les rôles de {organisation}',
  gererEquipe: 'Gérer l’équipe',
}
